import React from 'react'
import Line from './line'
import _ from 'lodash'


const Lines = () => {
    const lines = [
        { key: 0, title: String.raw`\(q_0: |0\rangle\)`, accepted: [0] },
        { key: 1, title: String.raw`\(q_1: |0\rangle\)`, accepted: [0, 1] },
        { key: 2, title: String.raw`\(q_2: |0\rangle\)`, accepted: [0, 1, 2] },
        { key: 3, title: String.raw`\(q_3: |0\rangle\)`, accepted: [0, 1, 2] },
        { key: 4, title: String.raw`\(q_4: |0\rangle\)`, accepted: [0, 1, 2] }
    ]

    return (
        <div className='grid max-content'>
            {lines.map(l =>
                <Line
                    id={l.key}
                    accepted={l.accepted}
                    key={l.key}
                    title={l.title}
                />
            )}
        </div>
    )
}

export default Lines;